import React from "react";
import { SEO, ChatMain, AdminLayout } from "../../../components";

const ChatPage = () => {
  return (
    <>
      <SEO title="Chat" />
      <AdminLayout>
        <ChatMain />
      </AdminLayout>
    </>
  );
};

export default ChatPage;
